.button {
    padding: 10px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    background-color: white;
    margin-left: 6px;
    margin-right: 6px;
    display: flex;
}


.colorCancel {
    color: white;
    background-color: gainsboro;
}


